module.exports = __webpack_public_path__ + "img/riddim-reggae.42c3b95d.png";